const resource = {
    resource_identifier_in_use: 'API tanımlayıcısı {{indicator}} zaten kullanımda',
};
export default Object.freeze(resource);
